import React from "react";
import { useTranslation } from "react-i18next";
import { useChatContext } from "./chat_context.jsx";
import IconSelector from "../../../components/Icon_Selector.js";


export default function ChatDocumentsSidebar() {
  const { t } = useTranslation("labels");

  const {
    chatHistoryNodes,
    headerHeight: contextHeaderHeight,
    showFolderDocuments,
    setShowFolderDocuments,
    folderFiles,
    headerHeight,
    currentUser,
  } = useChatContext();

  const openEditor = (file) => {
    window.location.href = `/ai-editor/${file.id}`;
  }


  return (
    <>
      <div
        className={`position-fixed d-flex flex-column bg-white border-start border-secondary shadow ${
          showFolderDocuments ? "end-0" : ""
        }`}
        style={{
          top: `${headerHeight}px`,
          height: `calc(100vh - ${headerHeight}px)`,
          width: "350px",
          zIndex: 1051,
          transition: "right 0.3s ease-in-out",
          right: showFolderDocuments ? "0" : "-350px",
        }}
      >
        <div className="d-flex justify-content-between align-items-center p-3 border-bottom bg-light">
          <h5 className="mb-0">
            {t("Edit Folder Documents", { ns: "labels" })}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setShowFolderDocuments(false)}
            aria-label="Close"
          ></button>
        </div>
        <div className="flex-grow-1" style={{ overflowY: "auto" }}>
          <div className="p-3">
            {chatHistoryNodes.folders.length > 0 && (
              <>
                <h6>
                  <i className="fa-solid fa-folder me-2"></i>
                  {t("folders", { ns: "labels" })}
                </h6>
                <ul className="list-unstyled mb-4">
                  {chatHistoryNodes.folders.map((folder) => (
                    <li key={folder.Id} className="mb-2">
                      <a
                        href={`/dms/chat/folder/${folder.Id}`}
                        className="text-decoration-none text-dark d-block p-2 rounded"
                        style={{ transition: "background-color 0.2s" }}
                        onMouseEnter={(e) =>
                          (e.target.style.backgroundColor = "#f1f1f1")
                        }
                        onMouseLeave={(e) =>
                          (e.target.style.backgroundColor = "")
                        }
                      >
                        {folder.Name}
                      </a>
                    </li>
                  ))}
                </ul>
              </>
            )}
            {folderFiles.length > 0 && (
              <>
                <h6>
                  <i className="fa-solid fa-file-alt me-2"></i>
                  {t("files", { ns: "labels" })}
                </h6>
                <ul className="list-unstyled">
                  {folderFiles.length === 0 ? (
                    <div className="p-3 text-muted">
                      {t("noFiles", { ns: "labels" })}
                    </div>
                  ) : (
                    folderFiles.map((file, index) => (
                      <div
                        key={file.id}
                        className={`tag-item p-2 d-flex align-items-center `}
                        onClick={() => openEditor(file)} 
                        style={{
                          cursor: "pointer",
                          borderBottom:
                            index < folderFiles.length - 1
                              ? "1px solid #eee"
                              : "none",
                          transition: "background-color 0.2s",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor = "#f1f1f1")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.backgroundColor = "")
                        }
                      >
                        <div
                          className="me-2 "
                          style={{ width: "16px", height: "16px" }}
                        >
                          <IconSelector
                            icon={file.type}
                            width="16"
                            height="16"
                          />
                        </div>
                        <span>{file.name}</span>
                      </div>
                    ))
                  )}
                </ul>
              </>
            )}
          </div>
        </div>
      </div>
      {showFolderDocuments && (
        <div
          className="modal-backdrop fade show"
          onClick={() => setShowFolderDocuments(false)}
          style={{ zIndex: 1050, display: "none" }}
        ></div>
      )}
    </>
  );
}
